import React from 'react';

import { type FWorkflowStepFragment, WorkflowStepStatus } from '@dashboard/generated/wp/platform';

import { DateFormatter } from '@waypoint/react-formatters';

type Props = {
  step: FWorkflowStepFragment;
};
export default function CardCaption({ step }: Props) {
  switch (step.status) {
    case WorkflowStepStatus.Processing:
      return (
        <>
          Started processing on <DateFormatter value={step.startedAt} template="full" />
        </>
      );
    case WorkflowStepStatus.Failed:
      return (
        <>
          Failed processing on <DateFormatter value={step.failedAt} template="full" />
        </>
      );
    case WorkflowStepStatus.Disabled:
      return (
        <>
          This step was disabled. Processed on <DateFormatter value={step.skippedAt} template="full" />
        </>
      );
    case WorkflowStepStatus.Succeeded:
      if (step.result?.sleep?.wakeupCommandAt) {
        return (
          <>
            Delay skipped on <DateFormatter value={step.finishedAt} template="full" />
          </>
        );
      }
      if (step.result?.sleep?.wokeupAt) {
        return (
          <>
            Woke up on <DateFormatter value={step.finishedAt} template="full" />
          </>
        );
      }

      return (
        <>
          Finished processing on <DateFormatter value={step.finishedAt} template="full" />
        </>
      );
    case WorkflowStepStatus.Canceled:
      return (
        <>
          Workflow canceled on <DateFormatter value={step.canceledAt} template="full" />
        </>
      );
    case WorkflowStepStatus.Pending:
    default:
      return <>Pending</>;
  }
}
